import {
  AccordionDetails as MUIAccordionDetails,
  type AccordionDetailsProps,
} from '@mui/material';

export { type AccordionDetailsProps } from '@mui/material';

export function AccordionDetails(props: AccordionDetailsProps) {
  return <MUIAccordionDetails {...props} />;
}
